import { useMemo, useState } from 'react';
import Slider from "react-slick";
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import _ from 'lodash';
import { SlickArrowLeft, SlickArrowRight, SlickProps } from '../../../lib/Slick';
import { Banner } from './Banner';

export const HomeBanner = () => {
    const [type, setType] = useState(null);

    const {data:homeList, isLoading, isSuccess} = useQuery({
        queryKey:['/home/banner'],
        queryFn:()=>Api.get('/api/banner/activeBanner'),
        staleTime:24*60*60*1000,
        gcTime:24*60*60*1000
    });

    const bannerList = useMemo(() => {
        if(isLoading)return null;
        if(!isSuccess)return null;
        if (homeList.data?.list == null || homeList.data?.list.length === 0) {
            return <div className="main_banner_wrap"><div className="no_data"><p>등록된 배너가 없습니다.</p></div></div>;
        }

        var importantList = _.filter(homeList.data?.list, item => item.important === 'Y');
        var normalList = _.shuffle(_.filter(homeList.data?.list, item => item.important === 'N'));
        var bannerListData = _.concat(importantList, normalList);
        return bannerListData.map((banner, key) => {
            if (null === banner.imagePc && null === banner.imageM) return null;
            if (type !== null && banner.type !== type) return null;

            return (
                <div className="slide_item" key={key}>
                    <Banner banner={banner} />
                </div>
            );
        });
    }, [homeList, isLoading, isSuccess, type]);
    

    return (
        <div className="main_banner_wrap">
            <ul className="contents">
                {homeList?.data?.eventCount > 0 &&
                    <li className={type === 'event' ? 'active' : ''} onClick={() => setType('event')}><div className="icon"><img src={`${process.env.PUBLIC_URL}/static/images/main/main_banner_contents_icon2.png`} alt="" /></div><div className="contents_title">독서행사</div></li>
                }
                {homeList?.data?.publisherCount > 0 &&
                    <li className={type === 'publisher' ? 'active' : ''} onClick={() => setType('publisher')} >
                        <div className="icon"><img src={`${process.env.PUBLIC_URL}/static/images/main/main_banner_contents_icon1.png`} alt="" /></div>
                        <div className="contents_title">문학행사</div>
                    </li>
                }
                {homeList?.data?.bookCount > 0 &&
                    <li className={type === 'book' ? 'active' : ''} onClick={() => setType('book')}><div className="icon"><img src={`${process.env.PUBLIC_URL}/static/images/main/main_banner_contents_icon3.png`} alt="" /></div><div className="contents_title">이런책어때요</div></li>
                }
            </ul>
            <Slider className="main_banner" {...SlickProps}
                slidesToShow={1} slidesToScroll={1} dots={false}
                prevArrow={<SlickArrowLeft cn="prev_btn _turq" />}
                nextArrow={<SlickArrowRight cn="next_btn _turq" />}
                autoplay={true}
                autoplaySpeed={5000}
                responsive={null}>
                {bannerList}
            </Slider>
        </div>
    )
}//